<div class="textarea">
  @if (label) {
  <span class="textarea__label">
    {{ label | translate }}
    @if (isRequired && !disabled) {
    <span class="color--red">*</span>
    }
  </span>
  }
  <textarea
    class="textarea__control"
    [placeholder]="placeholder | translate"
    [value]="value"
    (input)="onInput($event)"
    (blur)="onBlur()"
    [disabled]="disabled"
  ></textarea>
</div>
